import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { CatalogPriceRules } from 'src/app/models/catalog-price-rules';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CatalogPriceRulesService {


  constructor(private http: HttpClient) { }
  public responseCache = new Map();

  url = environment.serverAPI4 + "/api/catalogrules";

  searchCatalogrules(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  getCatalogrules(Page: number, size: number, sort: number): Observable<Object> {
    return this.http.get(`${this.url}/?page=${Page}&size=${size}&sort=${sort}`);

  }
  createCatalogrules(catalogPriceRules: CatalogPriceRules): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, catalogPriceRules);
  }

  getCatalogrulesById(ruleId: number): Observable<Object> {
    return this.http.get(`${this.url}/${ruleId}`);
  }

  fetchAlldropdownValueForRule(): Observable<Object> {
    return this.http.get(`${this.url}/dropDownValue`);
  }

  // public fetchAlldropdownValueForRule(): Observable<any> {
  //   const categoryFromCache = this.responseCache.get(`${this.url}/dropDownValue`);
  //   if (categoryFromCache) {
  //     return of(categoryFromCache);
  //   }
  //   const response = this.http.get<any>(`${this.url}/dropDownValue`);
  //   response.subscribe(category => this.responseCache.set(`${this.url}/dropDownValue`, category));
  //   return response;
  // }

}
